import { render, staticRenderFns } from "./TaxRules.vue?vue&type=template&id=4f8e3d2e&scoped=true"
import script from "./TaxRules.vue?vue&type=script&lang=js"
export * from "./TaxRules.vue?vue&type=script&lang=js"
import style0 from "./TaxRules.vue?vue&type=style&index=0&id=4f8e3d2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e3d2e",
  null
  
)

export default component.exports